module.exports = __webpack_public_path__ + "static/media/20.8ffbe646.jpg";